import request from '@/utils/request'

/**
 * 车辆事故案件列表
 */
export function  listCase(para) {
    return request({
        url: '/vehicle/case/pagelist',
        method: 'post',
        data: para
    })
}

/**
 * 可以报价的案件列表,并且包含报价信息
 * */ 
export function checkedQuoteListCase(para){
    return request({
        
        url: '/vehicle/quote/casePagelistQuote',
        method: 'post',
        data: para
    })
}

/**
 * 已经报价的列表
 * @param {*} para 
 */
export function haveQuoteListCase(para){
    return request({
        
        url: '/vehicle/quote/casePagelistHaveQuote',
        method: 'post',
        data: para
    })
}


/**
 * 增加车辆事故案件
 */
export function addCase(para){
    return request({
        url: '/vehicle/case/add',
        method: 'post',
        data: para
    })
}

//修改案件
export function updateCase(para){
    return request({
        url: '/vehicle/case/edit',
        method: 'post',
        data: para
    })
}

//移除车辆保险事故案件
export function removeCase(para){
    return request({
        url:'/vehicle/case/remove',
        method:'post',
        data:para
    })
}

/**
 * 进行收藏
 * @param {*} para 
 */
export function confirmCollectCase(para){
    para['collectStatus']='Y'
    return request({
        url:'/vehicle/case/collect',
        method:'post',
        data:para
    })
}

/**
 * 取消收藏
 * @param {*} para 
 */
export function cancelCollectCase(para){
    para['collectStatus']='N'
    return request({
        url:'/vehicle/case/collect',
        method:'post',
        data:para
    })
}

// 获取案件详情(get)
export function getCase(caseId){
    return request({
        url:'/vehicle/case/detail/'+ caseId,
        method:'get',
    })
}

// 获取案件分享的详情(get)
export function getCaseShareDetail(caseId){
    return request({
        url:'/vehicle/case/sharedetail/'+ caseId,
        method:'get',
    })
}


export function getCaseNoSurveyor(caseId){
    return request({
        url:'/vehicle/case/detailNoSurveyor/'+ caseId,
        method:'get',
    })
}

/**
 * 停止用户报价
 */
export function stopCaseQuote(caseId){
    return request({
        url:'vehicle/case/stopQuote/'+caseId,
        method:'get',
    });
}

/**
 * 提交给保险公司的投标信息
 * @param {*} para 
 * @returns 
 */
export function submitBid(para){
    return request({
        url:'vehicle/case/bid',
        method:'post',
        data:para
    });
}

/**
 * 提交中标结果
 */
export function updateCaseBidResultByCaseSn(para){
    return request({
        url:'/vehicle/case/updateCaseBidInfoByCaseSn',
        method:'post',
        data:para
    });
}

/**
 * 增加或更新 委托信息
 * @param {*} para 
 * @returns 
 */
export function addupdateVehicleEntrust(para){
    return request({
        url:'/vehicle/case/addEntrustInfo',
        method:'post',
        data:para
    })
}

/**
 * 增加或者更新 入库信息
 * @param {*} para 
 * @returns 
 */
export function addupdateVehicleStoreage(para){
    return request({
        url:'/vehicle/case/addStorageInfo',
        method:'post',
        data:para
    })
}

/***
 * 
 */
export function getEvaluateResults(para){
    return request({
        url:'/vehicle/case/getEvaluateResult',
        method:'post',
        data:para
    })
}

/***
 * 通过车辆型号；得到案件列表（历史报价记录，）
 * purpose：为了会员方便查询一个车辆的历史报价，为做参考
 */
export function getCaseListByVehicleModel(para){
    return request({
        url:'/vehicle/case/pagelistByVehicleModel',
        method:'post',
        data:para
    })
}